/* The Hollow Harvest · la Tally Card giocabile
   Nessuna dipendenza. Funziona con la tastiera perché i comandi sono bottoni
   veri, e funziona anche per chi ha chiesto meno animazioni: le classi che
   attivano le animazioni sono tutte @keyframes con animation-duration, e in
   hh-base.css c'è già una regola globale che porta quella durata a 0.001ms in
   prefers-reduced-motion: reduce. Qui non serve rifarla, basta non usare
   transition per gli effetti "one shot". */

(function () {
  'use strict';

  function init(root) {
    var data = root.querySelector('[data-hh-steps]');
    if (!data) return;

    var steps;
    try { steps = JSON.parse(data.textContent); } catch (e) { return; }
    if (!steps.length) return;

    var boxes = root.querySelectorAll('[data-hh-boxes] .hh-tally-box');
    var cuts = root.querySelectorAll('[data-hh-cuts] .hh-tally-cut');
    var scoreEl = root.querySelector('[data-hh-score]');
    var nameEl = root.querySelector('[data-hh-state-name]');
    var callEl = root.querySelector('[data-hh-call]');
    var stamp = root.querySelector('[data-hh-stamp]');
    var villageEl = root.querySelector('[data-hh-village]');
    var fieldEl = root.querySelector('[data-hh-field]');
    var upButtons = root.querySelectorAll('[data-hh-up]');
    var cutButton = root.querySelector('[data-hh-cut]');
    var resetButton = root.querySelector('[data-hh-reset]');

    var score = 0;
    var cutCount = 0;
    var hollow = false;
    var actionsDone = 0;
    var revertTimer = null;
    var priorName = (nameEl && nameEl.textContent) || 'Unknown';

    /* Ogni azione conta una volta sola: sei bottoni, sei ingressi nel
       registro. Prima si poteva cliccare lo stesso undici volte e vincere il
       Contest a occhi chiusi, il che rendeva il momento più drammatico della
       pagina un non-evento. */
    var usedFlags = [];
    for (var u = 0; u < upButtons.length; u++) usedFlags.push(false);

    var contest = root.querySelector('[data-hh-contest]');
    var rollBtn = root.querySelector('[data-hh-roll]');
    var foil = root.querySelector('[data-hh-foil]');
    var resBox = root.querySelector('[data-hh-contest-result]');
    var dieYou = root.querySelector('[data-hh-die-you]');
    var dieGuest = root.querySelector('[data-hh-die-guest]');
    var modsYou = root.querySelector('[data-hh-mods-you]');
    var modsGuest = root.querySelector('[data-hh-mods-guest]');
    var verdictEl = root.querySelector('[data-hh-verdict]');

    /* Rigioca una @keyframes su un elemento anche se la classe c'era già:
       toglie, forza il reflow, rimette. Senza il reflow il secondo clic di
       fila non si vedrebbe. */
    function pulse(el, cls) {
      if (!el) return;
      el.classList.remove(cls);
      void el.offsetWidth;
      el.classList.add(cls);
    }

    function stepFor(n) {
      var found = steps[0];
      for (var i = 0; i < steps.length; i++) if (Number(steps[i].score) <= n) found = steps[i];
      return found;
    }

    function render(line, opts) {
      var s = stepFor(score);
      var newName = hollow ? 'Hollow' : s.name;
      var tierChanged = newName !== priorName;

      boxes.forEach(function (b, i) { b.classList.toggle('is-marked', i < score); });
      boxes.forEach(function (b, i) { b.classList.toggle('is-last', i === 5 && score >= 6); });
      cuts.forEach(function (c, i) { c.classList.toggle('is-done', i < cutCount); });

      scoreEl.textContent = score;
      nameEl.textContent = newName;
      root.classList.toggle('is-entered', score >= 6);
      root.classList.toggle('is-hollow', hollow);
      if (stamp) stamp.classList.toggle('is-shown', hollow);

      if (hollow) {
        villageEl.textContent = 'Nobody recognises you. Not the village, not the book, not the people you rode in with.';
        fieldEl.textContent = 'You are not collected. You are not owed. You are not anything.';
      } else {
        villageEl.textContent = line || s.village;
        fieldEl.textContent = s.field;
      }

      upButtons.forEach(function (b, i) {
        b.disabled = hollow || score >= 6 || usedFlags[i];
        b.classList.toggle('is-used', usedFlags[i]);
      });
      cutButton.disabled = hollow || score <= 0;

      /* Il Contest entra e esce di scena, non compare e basta: e quando esce
         (un taglio ti riporta sotto sei) si porta via il tiro precedente,
         così se ci si torna più tardi non resta un verdetto vecchio in vista. */
      var wasContestVisible = contest && !contest.hidden;
      if (contest) {
        var showContest = score >= 6 && !hollow;
        contest.hidden = !showContest;
        if (showContest && !wasContestVisible) {
          contest.classList.remove('is-in');
          void contest.offsetWidth;
          window.requestAnimationFrame(function () { contest.classList.add('is-in'); });
        } else if (!showContest && wasContestVisible) {
          contest.classList.remove('is-in', 'is-win', 'is-lose', 'is-tie');
          if (resBox) resBox.hidden = true;
          if (verdictEl) verdictEl.textContent = '';
          if (rollBtn) rollBtn.disabled = false;
        }
      }

      /* Il DM lo direbbe ad alta voce: qui lo scrive la carta, e lo legge
         anche chi non la vede, perché la riga è in aria-live. Un salto di
         gradino (Named -> Counted) pesa di più di un punto dentro lo stesso
         gradino, e la carta lo mostra prima ancora di dirlo. */
      if (opts && opts.rose) {
        pulse(scoreEl, 'is-struck');
        if (tierChanged) {
          pulse(nameEl, 'is-tier-up');
          if (callEl) { callEl.textContent = 'Recognition rises. You are now ' + newName + '.'; pulse(callEl, 'is-flash'); }
        } else if (callEl) {
          callEl.textContent = 'Recognition rises. Balance ' + score + '.';
          pulse(callEl, 'is-flash');
        }
      } else if (opts && opts.cut) {
        pulse(scoreEl, 'is-struck');
        if (callEl) {
          callEl.textContent = hollow ? 'The third notch. You are Hollow.' : ('Notch cut. Balance ' + score + '.');
          pulse(callEl, 'is-flash');
        }
      }

      priorName = newName;
    }

    upButtons.forEach(function (btn, idx) {
      btn.addEventListener('click', function () {
        if (hollow || score >= 6 || usedFlags[idx]) return;
        usedFlags[idx] = true;
        score = Math.min(6, score + 1);
        actionsDone = Math.min(6, actionsDone + 1);
        render(btn.getAttribute('data-line'), { rose: true });
        clearTimeout(revertTimer);
        revertTimer = setTimeout(function () { if (!hollow) render(); }, 2600);
      });
    });

    cutButton.addEventListener('click', function () {
      if (hollow || score <= 0) return;
      cutCount = Math.min(3, cutCount + 1);
      score = Math.max(0, score - 1);
      if (cutCount >= 3) hollow = true;
      clearTimeout(revertTimer);
      render(cutCount >= 3 ? null : 'You give up one of the things they know you by. It does not come back.', { cut: true });
    });

    resetButton.addEventListener('click', function () {
      score = 0;
      cutCount = 0;
      hollow = false;
      actionsDone = 0;
      for (var i = 0; i < usedFlags.length; i++) usedFlags[i] = false;
      clearTimeout(revertTimer);
      if (resBox) resBox.hidden = true;
      if (verdictEl) verdictEl.textContent = '';
      if (contest) { contest.hidden = true; contest.classList.remove('is-in', 'is-win', 'is-lose', 'is-tie'); }
      if (rollBtn) rollBtn.disabled = false;
      if (callEl) callEl.textContent = '';
      priorName = (nameEl && nameEl.textContent) || 'Unknown';
      render();
    });

    /* Il Contest, cioè il finale. Regole del lorebook: due d20, tu aggiungi gli
       abitanti che diranno il tuo nome per te, il Guest aggiunge i suoi, e la
       mezza taglia ricevuta al Toll Stone vale cinque. La lettura di questo
       anno è undici, quindi gli abitanti si dividono fra voi due su undici.
       actionsDone ora sale al massimo a sei (un'azione, un uso), quindi il
       Contest non si può più vincere semplicemente spam-cliccando: al massimo
       porti sei voci dalla tua parte, mai tutte e undici. */
    if (rollBtn) {
      rollBtn.addEventListener('click', function () {
        var yours = Math.max(1, actionsDone);
        var theirs = Math.max(1, 11 - yours);
        var bonus = foil && foil.checked ? 5 : 0;

        var youRoll = 1 + Math.floor(Math.random() * 20);
        var guestRoll = 1 + Math.floor(Math.random() * 20);

        resBox.hidden = false;
        rollBtn.disabled = true;
        contest.classList.remove('is-win', 'is-lose', 'is-tie');
        if (verdictEl) verdictEl.textContent = '';

        var t = 0;
        var spin = setInterval(function () {
          dieYou.textContent = 1 + Math.floor(Math.random() * 20);
          dieGuest.textContent = 1 + Math.floor(Math.random() * 20);
          if (++t > 12) {
            clearInterval(spin);
            dieYou.textContent = youRoll;
            dieGuest.textContent = guestRoll;
            modsYou.textContent = 'plus ' + yours + ' villagers' + (bonus ? ' plus 5 for the foil' : '') + ', total ' + (youRoll + yours + bonus);
            modsGuest.textContent = 'plus ' + theirs + ' villagers, total ' + (guestRoll + theirs);

            var mine = youRoll + yours + bonus;
            var his = guestRoll + theirs;
            var outcome = mine > his ? 'win' : (mine === his ? 'tie' : 'lose');
            contest.classList.add('is-' + outcome);
            pulse(resBox, 'is-settled');

            var tally = 'You: ' + mine + '. The Guest: ' + his + '. ';
            if (outcome === 'win') {
              verdictEl.textContent = tally + 'The book settles the other entry. The Guest is returned, the account is square, and you ride out of Tithewick with your name still on you.';
            } else if (outcome === 'tie') {
              verdictEl.textContent = tally + 'A tie. You are both held over until the next reading, and the parish has to feed you for another year.';
            } else {
              verdictEl.textContent = tally + 'The village means the other one. You are the duplicate now, and everybody here is very sorry, and none of them stop it.';
            }
            rollBtn.disabled = false;
          }
        }, 70);
      });
    }

    render();
  }

  function boot() {
    document.querySelectorAll('[data-hh-tally]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
